'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
defineWellKnownSymbol('asyncDispose');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/modules/esnext.symbol.async-dispose.js
// module id = 376
// module chunks = 0 1 2 3